<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="2">
        <v-card flat>
          <v-list>
            <v-list-item-group v-model="selectedMenuItem">
              <v-list-item
                v-for="menuItem in menu"
                :key="menuItem.title"
                class="py-1"
              >
                {{ menuItem.title }}
              </v-list-item>
              <v-list-item
                download
                href="/CCA Quick Start_updated_10.2025.pdf"
              >
                {{ $t('dictionaries.userManual') }}
                <v-icon class="ml-2" size="medium">
                  mdi-download
                </v-icon>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12" md="10">
        <SkeletonTableLoader :items-length="dictionaries.employers.length">
          <component
            v-if="menu[selectedMenuItem]"
            :is="menu[selectedMenuItem].tableComponent || 'DictionaryTable'"
            :headers="menu[selectedMenuItem].headers"
            :items="menu[selectedMenuItem].items"
            item-key="id"
            :title="menu[selectedMenuItem].title"
            @ADD="menu[selectedMenuItem].handleAdd"
            @EDIT="menu[selectedMenuItem].handleEdit"
            @DELETE="menu[selectedMenuItem].handleDelete"
          />
        </SkeletonTableLoader>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getAllEmployers, getAllDictionariesForAdminPanel, getAllContractors, deleteDictionaryItem, deleteContractor, deleteEmployer, saveDictionaryItem } from '../services'
import { projectModel, packageModel, typeModel, workstreamModel, guaranteeNameModel, categoryModel, accessModel, currencyModel } from '@/validators'

const DEFAULT_CURRENCY = {
  code: '',
  symbol: ''
}
const DEFAULT_PROJECT = {
  name: '',
  code: '',
  areas: '',
  users: []
}
const DEFAULT_PACKAGE = {
  name: '',
  areas: ''
}
const DEFAULT_TYPE = {
  name: '',
  areas: ''
}
const DEFAULT_WORKSTREAM = {
  name: '',
  area: 'OFF',
  type: 'claim'
}
const DEFAULT_CATEGORY = {
  name: '',
  area: 'OFF',
  type: 'claim'
}
const DEFAULT_ACCESS = {
  user: '',
  project: ''
}
const DEFAULT_GUARANTEE_NAME = {
  name: ''
}

export default {
  name: 'AdminView',
  props: { },
  data () {
    return {
      selectedComponent: { headers: [], handleDelete: () => {}, handleAdd: () => {}, handleEdit: () => {} },
      selectedMenuItem: null,
      dictionaries: { employers: [], contractors: [] }
    }
  },
  computed: {
    packages () {
      return this.dictionaries.packages
    },
    risks () {
      return this.dictionaries.risks
    },
    projects () {
      return this.dictionaries.projects
    },
    contractTypes () {
      return this.dictionaries.types
    },
    employers () {
      return this.dictionaries.employers.map(item => ({ ...item, address: `${item.street} ${item.houseNumber}, ${item.zipCode} ${item.city}, ${item.state}` }))
    },
    contractors () {
      return this.dictionaries.contractors.map(item => ({ ...item, address: `${item.street} ${item.houseNumber}, ${item.zipCode} ${item.city}, ${item.state}` }))
    },
    currencies () {
      return this.dictionaries.currencies
    },
    workstreams () {
      return this.dictionaries.workstreams
    },
    variationsCategories () {
      return this.dictionaries.categories
    },
    workflowStepsNames () {
      return this.dictionaries.workflowStepsNames
    },
    usersAccessData () {
      return this.dictionaries.userAccess
    },
    areas () {
      return this.dictionaries.areas
    },
    guaranteesNames () {
      return this.dictionaries.guaranteesNames
    },
    menu () {
      return [
        {
          title: this.$tc('dictionaries.userAccess', 2),
          tableComponent: 'UsersAccessTable',
          handleAdd: this.handleAddAccess,
          handleEdit: this.handleAddAccess,
          handleDelete: this.handleDeleteItem('userAccess', 0),
          items: this.usersAccessData
        },
        {
          title: this.$tc('contract.project.OFF', 2),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$t('dictionaries.code'), value: 'code' },
            { text: this.$tc('contract.area', 2), value: 'areas' },
            { text: this.$tc('dictionaries.user', 2), value: 'users' }
          ],
          handleAdd: this.handleAddProject,
          handleEdit: this.handleAddProject,
          handleDelete: this.handleDeleteItem('projects', 1),
          items: this.projects
        },
        {
          title: this.$tc('contract.package', 2),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$tc('contract.area', 2), value: 'areas' }
          ],
          handleAdd: this.handleAddPackages,
          handleEdit: this.handleAddPackages,
          handleDelete: this.handleDeleteItem('packages', 2),
          items: this.packages
        },
        {
          title: this.$tc('contract.type', 2),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$tc('contract.area', 2), value: 'areas' }
          ],
          handleAdd: this.handleAddType,
          handleEdit: this.handleAddType,
          handleDelete: this.handleDeleteItem('contractTypes', 3),
          items: this.contractTypes
        },
        {
          title: this.$t('dictionaries.workstreams'),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$tc('contract.area', 1), value: 'area' },
            { text: this.$t('dictionaries.type'), value: 'type' }
          ],
          handleAdd: this.handleAddWorkstreams,
          handleEdit: this.handleAddWorkstreams,
          handleDelete: this.handleDeleteItem('workstream', 4),
          items: this.workstreams
        },
        {
          title: this.$t('dictionaries.categories'),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$tc('contract.area', 1), value: 'area' },
            { text: this.$t('dictionaries.type'), value: 'type' }
          ],
          handleAdd: this.handleAddCategory,
          handleEdit: this.handleAddCategory,
          handleDelete: this.handleDeleteItem('categories', 5),
          items: this.variationsCategories
        },
        {
          title: this.$tc('contract.employer', 2),
          headers: [
            { text: this.$t('dictionaries.companyName'), value: 'companyName' },
            { text: this.$t('dictionaries.address'), value: 'address' }
          ],
          handleAdd: this.handleAddEmployer,
          handleEdit: this.handleAddEmployer,
          handleDelete: this.handleDeleteEmployer,
          items: this.employers
        },
        {
          title: this.$tc('contract.contractor', 2),
          headers: [
            { text: this.$t('common.name'), value: 'companyName' },
            { text: this.$t('dictionaries.address'), value: 'address' },
            { text: this.$t('dictionaries.sapNumber'), value: 'sapVendorNumber' }
          ],
          handleAdd: this.handleAddContractor,
          handleEdit: this.handleAddContractor,
          handleDelete: this.handleDeleteContractors,
          items: this.contractors
        },
        {
          title: this.$tc('contract.currency', 2),
          headers: [
            { text: this.$t('dictionaries.code'), value: 'code' },
            { text: this.$t('dictionaries.symbol'), value: 'symbol' }
          ],
          handleAdd: this.handleAddCurrency,
          handleEdit: this.handleAddCurrency,
          handleDelete: this.handleDeleteItem('currencies', 8),
          items: this.currencies
        },
        {
          title: this.$tc('dictionaries.risk', 2),
          headers: [
            { text: this.$t('common.name'), value: 'name' },
            { text: this.$t('common.description'), value: 'description' }
          ],
          handleAdd: this.handleAddRisk,
          handleEdit: this.handleAddRisk,
          handleDelete: this.handleDeleteItem('risks', 9),
          items: this.risks
        },
        {
          title: this.$tc('dictionaries.guaranteeName', 2),
          headers: [
            { text: this.$t('common.name'), value: 'name' }
          ],
          handleAdd: this.handleAddGuaranteeName,
          handleEdit: this.handleAddGuaranteeName,
          handleDelete: this.handleDeleteItem('guarantees-names', 10),
          items: this.guaranteesNames
        }
      ]
    }
  },
  async mounted () {
    this.dictionaries = await getAllDictionariesForAdminPanel()
    this.selectedMenuItem = 0
  },
  methods: {
    async handleDeleteEmployer (id) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        options: { maxWidth: 650 },
        scope: {
          message: this.$t('dictionaries.deleteWillAffect')
        },
        handlers: {
          yes: async () => {
            await deleteEmployer(id)
            this.dictionaries = await getAllDictionariesForAdminPanel()
            this.selectedComponent = this.menu[6]
          }
        }
      })
    },
    async handleDeleteContractors (id) {
      this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
        options: { maxWidth: 650 },
        scope: {
          message: this.$t('dictionaries.deleteWillAffect')
        },
        handlers: {
          yes: async () => {
            await deleteContractor(id)
            this.dictionaries = await getAllDictionariesForAdminPanel()
            this.selectedComponent = this.menu[7]
          }
        }
      })
    },
    handleDeleteItem (type, index) {
      return async (id) => {
        this.$eventBus.$emit('OPEN_CONFIRM_MODAL', {
          scope: {
            message: this.$t('dictionaries.deleteConfirm')
          },
          handlers: {
            yes: async () => {
              await deleteDictionaryItem(type, id)
              this.dictionaries = await getAllDictionariesForAdminPanel()
              this.selectedComponent = this.menu[index]
            }
          }
        })
      }
    },
    handleAddCurrency (item) {
      const handleSave = async (currency) => {
        await saveDictionaryItem('currencies', currency)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[8]
      }
      this.addDictionaryItem(
        { ...DEFAULT_CURRENCY, ...item },
        this.$t('dictionaries.addNew.currency'),
        {},
        handleSave,
        currencyModel
      )
    },
    handleAddEmployer (item) {
      const handleSave = async () => {
        await getAllEmployers()
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[6]
      }
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'EmployerForm',
        options: { maxWidth: 650 },
        scope: { value: item },
        handlers: {
          setnewemployer: handleSave
        }
      })
    },
    handleAddContractor (item) {
      const handleSave = async () => {
        await getAllContractors()
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[9]
      }
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'ContractorForm',
        options: { maxWidth: 650 },
        scope: { value: item },
        handlers: {
          setnewcontractor: handleSave
        }
      })
    },
    handleAddProject (item = {}) {
      const handleSave = async (project) => {
        project.users = project.users.map(i => i.mailNickname || i)
        await saveDictionaryItem('projects', project)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[1]
      }
      this.addDictionaryItem(
        { ...DEFAULT_PROJECT, ...item },
        this.$t('dictionaries.addNew.project'),
        {
          areas: { items: Object.values(this.areas) }
        },
        handleSave,
        projectModel
      )
    },
    handleAddPackages (item = {}) {
      const handleSave = async (item) => {
        await saveDictionaryItem('packages', item)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[2]
      }
      this.addDictionaryItem(
        { ...DEFAULT_PACKAGE, ...item },
        this.$t('dictionaries.addNew.package'),
        { areas: { items: Object.values(this.areas) } },
        handleSave,
        packageModel
      )
    },
    handleAddType (item = {}) {
      const handleSave = async (type) => {
        await saveDictionaryItem('contractTypes', type)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[3]
      }
      this.addDictionaryItem(
        { ...DEFAULT_TYPE, ...item },
        this.$t('dictionaries.addNew.type'),
        { areas: { items: Object.values(this.areas) } },
        handleSave,
        typeModel
      )
    },
    handleAddWorkstreams (item = {}) {
      const handleSave = async (workstreams) => {
        workstreams.areaCode = workstreams.area.code || workstreams.area
        workstreams.area = undefined
        await saveDictionaryItem('workstream', workstreams)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[4]
      }
      this.addDictionaryItem(
        { ...DEFAULT_WORKSTREAM, ...item },
        this.$t('dictionaries.addNew.workstream'),
        {
          area: { items: Object.values(this.areas) },
          type: { items: ['variation', 'claim'] }
        },
        handleSave,
        workstreamModel
      )
    },
    handleAddCategory (item = {}) {
      const handleSave = async (category) => {
        category.areaCode = category.area.code || category.area
        category.area = undefined
        await saveDictionaryItem('categories', category)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[5]
      }
      this.addDictionaryItem(
        { ...DEFAULT_CATEGORY, ...item },
        this.$t('dictionaries.addNew.rootCause'),
        {
          area: { items: Object.values(this.areas) },
          type: { items: ['variation', 'claim', 'claim-contractor', 'claim-employer'] }
        },
        handleSave,
        categoryModel
      )
    },
    handleAddAccess (item) {
      const handleSave = async (access) => {
        await saveDictionaryItem('userAccess', {
          mailNickname: access.user,
          resourceKey: 'projectId',
          resourceId: access.project
        })
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[0]
      }
      this.addDictionaryItem(
        { ...DEFAULT_ACCESS, ...item },
        this.$t('dictionaries.addNew.userAccess'),
        { project: { items: this.dictionaries.projects, type: 'select' } },
        handleSave,
        accessModel
      )
    },
    handleAddGuaranteeName (item = {}) {
      const handleSave = async (name) => {
        await saveDictionaryItem('guarantees-names', name)
        this.dictionaries = await getAllDictionariesForAdminPanel()
        this.selectedComponent = this.menu[10]
      }
      this.addDictionaryItem(
        { ...DEFAULT_GUARANTEE_NAME, ...item },
        this.$t('dictionaries.addNew.guaranteeName'),
        {},
        handleSave,
        guaranteeNameModel
      )
    },
    handleAddRisk (item = {}) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'RiskForm',
        options: { maxWidth: 650 },
        scope: { value: item },
        handlers: {
          save: async () => {
            this.$eventBus.$emit('CLOSE_MODAL')
            this.dictionaries = await getAllDictionariesForAdminPanel()
            this.selectedComponent = this.menu[9]
          },
          cancel: () => {
            this.$eventBus.$emit('CLOSE_MODAL')
          }
        }
      })
    },
    addDictionaryItem (item, title, fields, handleSave, validationModel) {
      this.$eventBus.$emit('OPEN_MODAL', {
        component: 'DictionaryForm',
        options: { maxWidth: 650 },
        scope: {
          value: item,
          title,
          fields,
          validationModel
        },
        handlers: {
          SAVE: handleSave
        }
      })
    }
  }
}
</script>
